import { owaConnectedAccountAdded } from 'owa-account-store-init';
import { addOWAConnectedAccount, getOWAConnectedAccountStatus } from 'owa-accounts-store';
import { getDefaultRequestOptions } from 'owa-headers';
import { getUserMailboxInfo } from 'owa-client-ids';
import { orchestrator } from 'satcheljs';
import { trace } from 'owa-trace';
import { loadWorkloadScenarioSettings } from 'owa-scenario-settings';
import getOwaUserConfigurationOperation from 'owa-service/lib/operation/getOwaUserConfigurationOperation';
import { setUserConfiguration } from 'owa-session-store';
import { initializeCalendarsCache, CalendarEndpointType } from 'owa-calendar-cache-loader';

//$NOTE(fpintos): I'm looking for the right place where this orchestrator should live.
// At first I had it on the owa-accounts-store itself, but at caused a circular reference
// between owa-accounts-store and owa-headers. It honestly feels like it should be in owa-session-store
// but then again, owa-session-store has no reference to owa-headers. It almost feels like owa-headers
// is in the wrong place (it currently lives in controls, shouldn't it be under framework?)
// I moved it back here so we can continue the OneView work but I suppose it will need to move soon.
// If we do move it, update owa-calendar-module-store\lib\actions\initializeState.ts also.

orchestrator(addOWAConnectedAccount, async ({ primarySmtpAddress }) => {
    try {
        const mailboxInfo = getUserMailboxInfo(primarySmtpAddress);
        const requestOptions = await getDefaultRequestOptions(mailboxInfo);

        // If fetching the refresh token fails while getting the request options, then the connected
        // account is marked as invalid, so we need to also check this before we call getOwaUserConfig
        // for this account
        const isAccountValid = getOWAConnectedAccountStatus(primarySmtpAddress);

        if (requestOptions.headers && isAccountValid) {
            // $TODO: we need to figure out when to retry this call if it fails.
            const userConfiguration = await getOwaUserConfigurationOperation(requestOptions);

            setUserConfiguration(userConfiguration, primarySmtpAddress);
            trace.info(`${primarySmtpAddress} initialized.`);

            // Load the workload scenario settings for the connected account
            // VSO # 55057 tracks the refactoring to move out the initializeCalendarsCache. We decided
            // that the best place for calling workload settings meanwhile is within this orchestrator.
            loadWorkloadScenarioSettings(primarySmtpAddress);

            // VSO # 55057 Once the initializeCalendarsCache is removed from this orchestrator, this
            // action can be removed
            owaConnectedAccountAdded(primarySmtpAddress);

            // initialize the cache for the connected account
            await initializeCalendarsCache(CalendarEndpointType.Outlook, primarySmtpAddress);
        }
    } catch (error) {
        // $TODO: this needs to be reported in the account object.
        trace.error(`${primarySmtpAddress} failed to initialize: ${error}`);
    }
});
